var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageUnreadOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 3.5C20.3199 3.5 25.4999 7.94 25.4999 13.5C25.4999 19.06 20.3199 23.5 13.9999 23.5C12.6452 23.5 11.3219 23.2962 10.0757 22.9034C8.67369 24.2092 6.61764 24.8966 3.95202 25.0012C3.72954 25.0099 3.50808 24.9667 3.30519 24.875C2.58369 24.5488 2.26318 23.6996 2.58925 22.9778C3.5 20.9632 4.00227 19.4801 4.10288 18.5994C3.06161 17.073 2.49995 15.3231 2.49995 13.5C2.49995 7.94 7.67995 3.5 13.9999 3.5ZM13.9999 5.5C8.72197 5.5 4.49995 9.11887 4.49995 13.5C4.49995 15.0077 4.99679 16.4549 5.92617 17.7133C6.05394 17.8863 6.12254 18.0959 6.12177 18.3109C6.11804 19.358 5.67255 20.8776 4.79196 22.9378C6.77862 22.7298 8.17963 22.1066 9.03653 21.1014C9.30967 20.7811 9.75421 20.6661 10.1484 20.8138C11.3498 21.264 12.6542 21.5 13.9999 21.5C19.2779 21.5 23.4999 17.8811 23.4999 13.5C23.4999 9.11887 19.2779 5.5 13.9999 5.5ZM13.9999 12C15.1045 12 15.9999 12.8954 15.9999 14C15.9999 15.1046 15.1045 16 13.9999 16C12.8954 16 11.9999 15.1046 11.9999 14C11.9999 12.8954 12.8954 12 13.9999 12Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageUnreadOutline);
export default __webpack_public_path__ + "static/media/message_unread_outline.0766ca0a5f9498703af10c7e023cc46a.svg";
export { ForwardRef as ReactComponent };